export default __webpack_public_path__ + "static/4-f3f694fc2bf5cde55df15211682e85db.png";